// 3rd
import { Model } from '@vuex-orm/core';
// models
import Brand from './Brand';
import NewsCategory from './NewsCategory';

export default class HeroNews extends Model {
    static entity = 'hero-news-articles';

    static fields() {
        return {
            id: this.attr(null),
            headline: this.attr(null),
            teasertext: this.attr(null),
            content: this.attr(null),
            image_header: this.attr(''),
            image_preview: this.attr(''),
            date_of_news: this.attr(null),
            brands: this.attr(null),
            categories: this.attr(null),
            related_brands: this.hasManyBy(Brand, 'brands'),
            related_categories: this.hasManyBy(NewsCategory, 'categories'),
        }
    }

    static get() {
        return HeroNews.query().orderBy('created_at', 'desc').limit(1).withAll().first();
    }
}
